import axios from "axios";
import { getToken } from "./get-token"; // Change to a regular function

const http_formData = axios.create({
  baseURL: "/api",
  // baseURL: process.env.REACT_APP_API_BASE_URL_DEMO,
  // baseURL: process.env.REACT_APP_API_BASE_URL_LIVE,
  timeout: 30000,
  headers: {
    "Content-Type": "multipart/form-data",
    Authorization: "Basic d2luYXBwOmFkbWlu",
  },
  withCredentials: true,
  // credentials: "include",
  // secure: false
});

http_formData.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // 🔐 Cookie expired or invalid
      localStorage.clear();
      sessionStorage.clear();

      window.location.href = "/Login"; // auto logout
    }

    return Promise.reject(error);
  }
);

export default http_formData;
